import React from "react";
import Banner from "./Banner/Banner";
import InsituteIcon from "../../assets/images/insituteIconOrange.svg";
import InsituteImg1 from "../../assets/images/insituteImg1.svg";
import InsituteImg2 from "../../assets/images/insituteImg2.svg";

import InvividualExcellanceImg1 from "../../assets/images/individualExcellanceImg1.svg";
import InvividualExcellanceImg2 from "../../assets/images/individualExcellanceImg2.svg";
import InvividualExcellanceImg3 from "../../assets/images/individualExcellanceImg3.svg";
import InvividualExcellanceImg4 from "../../assets/images/individualExcellanceImg4.svg";
import InvividualExcellanceImg5 from "../../assets/images/individualExcellanceImg5.svg";

import SpecialCriteriaImg1 from "../../assets/images/SpecialCriteriaImg1.svg";
import SpecialCriteriaImg2 from "../../assets/images/SpecialCriteriaImg2.svg";
import SpecialCriteriaImg3 from "../../assets/images/SpecialCriteriaImg3.svg";
import SpecialCriteriaImg4 from "../../assets/images/SpecialCriteriaImg4.svg";
import SpecialCriteriaImg5 from "../../assets/images/SpecialCriteriaImg5.svg";

import { aboutAwardsData, ResearchPublisingData } from "./AwardsData";
import FooterTop from "./FooterTop/FooterTop";
import styles from "./Awards.module.css";
import SelectionProcess from "./SelectionProcess/SelectionProcess";

const Awards = () => {
  return (
    <main className={styles.awardsPage}>
      <Banner />

      <section className={`${styles.commonSection} ${styles.aboutAward}`}>
        <div className={styles.container}>
          <h3>
            About the <span>Awards</span>
          </h3>
          <h5>
            The IMPARC Academic Excellence Awards recognize outstanding
            achievements across multiple dimensions of academic excellence,
            fostering a culture of innovation, integrity, and impact in higher
            education.
          </h5>

          <div className={styles.cards}>
            {aboutAwardsData.map((m, idx) => (
              <div key={idx} className={styles.card}>
                <figure>
                  <img src={m.img} alt={m.name} />
                </figure>
                <h4>{m.title}</h4>
                <p>{m.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={`${styles.commonSection} ${styles.awardCategories}`}>
        <div className={styles.container}>
          <h3>
            Award <span>Categories</span>
          </h3>
          <h5>
            Our comprehensive awards program recognizes excellence across
            multiple dimensions of academic achievement
          </h5>
          <h4 className={styles.headingwithIcon}>
            <img src={InsituteIcon} alt={" Institutional Excellence"} />
            Institutional Excellence
          </h4>
          <div className={styles.cards}>
            <div className={styles.card}>
              <figure>
                <img src={InsituteImg1} alt={"Best Institution (Overall)"} />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Institution (Overall)</h4>
                <p>
                  Outstanding academic performance, research excellence, and
                  measurable societal impact across all institutional functions.
                </p>
                <button className={styles.cardBtn}>Nominate Institution</button>
              </div>
            </div>
            <div className={styles.card}>
              <figure>
                <img
                  src={InsituteImg2}
                  alt={"Best Knowledge Partner Institution"}
                />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Knowledge Partner Institution</h4>
                <p>
                  Active engagement in IMPARC programs, exceptional knowledge
                  sharing, and collaborative partnerships.
                </p>
                <button className={styles.cardBtn}>Nominate Partner</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`${styles.commonSection} ${styles.individualExcellance}`}
      >
        <div className={styles.container}>
          <h3>
            Individual <span>Excellence</span>
          </h3>
          <div className={styles.cards}>
            <div className={styles.card}>
              <figure>
                <img
                  src={InvividualExcellanceImg1}
                  alt={"Best Administrator"}
                />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Administrator</h4>
                <p>
                  Visionary leadership and institutional transformation by Vice
                  Chancellors, Principals, or Deans.
                </p>
                <button className={styles.cardBtn}>Nominate</button>
              </div>
            </div>
            <div className={styles.card}>
              <figure>
                <img
                  src={InvividualExcellanceImg2}
                  alt={"Best Academic Leader"}
                />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Academic Leader</h4>
                <p>
                  Departmental innovation and research culture building by Heads
                  of Department or Program Chairs.
                </p>
                <button className={styles.cardBtn}>Nominate</button>
              </div>
            </div>
            <div className={styles.card}>
              <figure>
                <img src={InvividualExcellanceImg3} alt={"Best Researcher"} />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Researcher</h4>
                <p>
                  High-impact publications, patents, funded projects, and
                  groundbreaking research contributions.
                </p>
                <button className={styles.cardBtn}>Nominate</button>
              </div>
            </div>
            <div className={styles.card}>
              <figure>
                <img src={InvividualExcellanceImg4} alt={"Best Mentor"} />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Mentor</h4>
                <p>
                  Exceptional guidance to scholars, mentees, and institutional
                  teams with measurable impact.
                </p>
                <button className={styles.cardBtn}>Nominate</button>
              </div>
            </div>
            <div className={styles.card}>
              <figure>
                <img src={InvividualExcellanceImg5} alt={"Best Academician"} />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Academician</h4>
                <p>
                  Excellence in teaching, innovative curriculum design, and
                  outstanding student engagement.
                </p>
                <button className={styles.cardBtn}>Nominate</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={`${styles.commonSection} ${styles.aboutAward}`}>
        <div className={styles.container}>
          <h3>
            Research and <span>Publishing</span>
          </h3>

          <div className={styles.cards}>
            {ResearchPublisingData.map((m, idx) => (
              <div key={idx} className={styles.card}>
                <figure>
                  <img src={m.img} alt={m.name} />
                </figure>
                <h4>{m.title}</h4>
                <p>{m.desc}</p>
                <button className={`${styles.cardBtn} ${styles.widthAuto}`}>
                  Nominate
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section
        className={`${styles.commonSection} ${styles.nominationCriteria}`}
      >
        <div className={styles.container}>
          <h3>
            Nomination <span>Criteria</span>
          </h3>
          <h5>General eligibility requirements for all award categories</h5>

          <div className={styles.cards}>
            <div className={styles.card}>
              <div className={styles.rightBlock}>
                <h4 className={styles.blueHeadingArrow}>
                  General Requirements
                </h4>
                <p className={`${styles.icons} ${styles.blueWhiteCircle}`}>
                  Nominee must be from a recognized higher education
                  institution, research body, or relevant professional
                  organization
                </p>
                <p className={`${styles.icons} ${styles.blueWhiteCircle}`}>
                  Demonstrated alignment with IMPARC values — integrity, impact,
                  inclusivity, innovation
                </p>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.rightBlock}>
                <h4 className={styles.generalRequirements}>
                  General Requirements
                </h4>
                <p className={`${styles.icons} ${styles.insituteAward}`}>
                  <strong>Institutional awards:</strong> Must be
                  UGC/AICTE/NAAC/NIRF recognized or equivalent
                </p>
                <p className={`${styles.icons} ${styles.blueAward}`}>
                  <strong>Individual awards:</strong> Minimum 5 years of
                  academic/research experience (except student awards)
                </p>
                <p className={`${styles.icons} ${styles.blueResearch}`}>
                  <strong>Research paper awards:</strong> Must be published in
                  the last 2 years in a recognized journal/conference
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`${styles.commonSection} ${styles.individualExcellance}`}
      >
        <div className={styles.container}>
          <h3>
            Special <span>Criteria</span>
          </h3>
          <h5>General eligibility requirements for all award categories</h5>
          <div className={styles.cards}>
            <div className={styles.card}>
              <figure>
                <img src={SpecialCriteriaImg1} alt={"Lifetime Achievement"} />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Lifetime Achievement</h4>
                <p>
                  Visionary leadership and institutional transformation by Vice
                  Chancellors, Principals, or Deans.
                </p>
                <button className={styles.cardBtn}>Nominate</button>
              </div>
            </div>
            <div className={styles.card}>
              <figure>
                <img src={SpecialCriteriaImg2} alt={"Best Academic Leader"} />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Academic Leader</h4>
                <p>
                  Departmental innovation and research culture building by Heads
                  of Department or Program Chairs.
                </p>
                <button className={styles.cardBtn}>Nominate</button>
              </div>
            </div>
            <div className={styles.card}>
              <figure>
                <img src={SpecialCriteriaImg3} alt={"Best Researcher"} />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Researcher</h4>
                <p>
                  High-impact publications, patents, funded projects, and
                  groundbreaking research contributions.
                </p>
                <button className={styles.cardBtn}>Nominate</button>
              </div>
            </div>
            <div className={styles.card}>
              <figure>
                <img src={SpecialCriteriaImg4} alt={"Best Mentor"} />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Mentor</h4>
                <p>
                  Exceptional guidance to scholars, mentees, and institutional
                  teams with measurable impact.
                </p>
                <button className={styles.cardBtn}>Nominate</button>
              </div>
            </div>
            <div className={styles.card}>
              <figure>
                <img src={SpecialCriteriaImg5} alt={"Best Academician"} />
              </figure>
              <div className={styles.rightBlock}>
                <h4>Best Academician</h4>
                <p>
                  Excellence in teaching, innovative curriculum design, and
                  outstanding student engagement.
                </p>
                <button className={styles.cardBtn}>Nominate</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`${styles.commonSection} ${styles.SubmissionRequirement}`}
      >
        <div className={styles.container}>
          <h3>
            Submission <span>Requirements</span>
          </h3>

          <div className={styles.cards}>
            <div className={styles.card}>
              <div className={styles.rightBlock}>
                <h4>Required Documents</h4>
                <p className={`${styles.icons} ${styles.submissionIcon1}`}>
                  Completed nomination form
                </p>
                <p className={`${styles.icons} ${styles.submissionIcon2}`}>
                  CV/profile of nominee (PDF)
                </p>
                <p className={`${styles.icons} ${styles.submissionIcon3}`}>
                  Statement of contribution (max 500 words)
                </p>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.rightBlock}>
                <h4>Supporting Materials</h4>
                <p className={`${styles.icons} ${styles.submissionIcon4}`}>
                  Supporting documents (publications, awards, project reports,
                  testimonials)
                </p>
                <p className={`${styles.icons} ${styles.submissionIcon5}`}>
                  For institutions: Proof of accreditation and recognition
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.selectonProcess}>
        <div className={styles.container}>
          <SelectionProcess />
        </div>
      </div>
      <section
        className={`${styles.commonSection} ${styles.nominationCriteria}`}
      >
        <div className={styles.container}>
          <h3>
            Terms & <span>Conditions</span>
          </h3>
          <h5>
            Important guidelines and policies governing the awards program
          </h5>
          <div className={styles.cards}>
            <div className={styles.card}>
              <div className={styles.rightBlock}>
                <p className={`${styles.icons} ${styles.blueArrow}`}>
                  <strong>All awards are honorary</strong> and carry a
                  certificate/trophy; monetary grants may be announced
                  separately
                </p>
                <p className={`${styles.icons} ${styles.blueArrow}`}>
                  <strong> IMPARC reserves</strong> the right to withdraw an
                  award if misconduct or misrepresentation is found
                </p>
                <p className={`${styles.icons} ${styles.blueArrow}`}>
                  <strong>Decisions of the selection committees</strong> are
                  final and binding
                </p>
                <p className={`${styles.icons} ${styles.blueArrow}`}>
                  <strong>A nominee may be considered</strong> for multiple
                  awards, but cannot receive more than one in a year
                </p>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.rightBlock}>
                <p className={`${styles.icons} ${styles.blueArrow}`}>
                  <strong> Self-</strong>nominations are accepted for eligible
                  categories
                </p>
                <p className={`${styles.icons} ${styles.blueArrow}`}>
                  <strong>All submitted material </strong>may be used in IMPARC
                  publications, reports, and promotions
                </p>
                <p className={`${styles.icons} ${styles.blueArrow}`}>
                  <strong>Participation implies</strong> acceptance of these
                  terms
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterTop />
    </main>
  );
};

export default Awards;
